import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { DashboardLayout } from "src/components/dashboard";
import { DashboardContainer } from "../dashboard/Dashboard";
import { ScaleLoader } from "react-spinners";
import OccupationTable from "src/components/Others/OccupationTable";
import { RhsHeading } from "../admin/Admin";
import AddOccupationModal from "src/components/Others/AddOccupationModal";
import { useAppDispatch, useAppSelector } from "src/store";
import {
  setOccupations,
  setLoadingOccupations,
  setMiscSearchField,
  useGetOccupationsQuery,
} from "src/store";
import { useLazyExportVendorsQuery } from "src/store/services/miscApi";
import { useLoading } from "src/hooks";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";
import { PaginationProps } from "src/components/ui/Pagination";

type Props = {};

const Occupation = (props: Props) => {
  const dispatch = useAppDispatch();
  const { occupations, loadingOccupations, searchField } = useAppSelector(
    (state) => state.misc,
  );

  const [open, setOpen] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [shouldExport, setShouldExport] = useState(false);
  const [ssearchField, setSearchField] = useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [Ppage, setPage] = useState(1);


  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const { data, error, isLoading } = useGetOccupationsQuery({
    page: Ppage,
    limit: 10,
    search: ssearchField,
  });
  const [exportVendors, { data: exportData, isLoading: isExporting }] =
    useLazyExportVendorsQuery();

  const {
    loading: exportingData,
    startLoading: startExportingData,
    stopLoading: stopExportingData,
  } = useLoading(false);

  useEffect(() => {
    if (data?.payload?.data) {
      dispatch(setOccupations(data.payload.data));
    }
    if (data?.payload?.pagination) {
      setPaginationData(data?.payload?.pagination);
    }
  }, [data, dispatch]);

  // Handle export response
  useEffect(() => {
    if (!shouldExport || !exportData) return;
    const url = exportData?.payload?.data?.fileUrl;
    if (url) {
      toast.success(exportData?.message || "Export started");
      window.location.href = url;
    }
    setShouldExport(false);
    setShowExportModal(false);
    stopExportingData();
  }, [exportData, shouldExport, stopExportingData]);

    useEffect(() => {
    document.title = "Occupation Page";
  }, []);

  const handleChange = (e: any) => {
    dispatch(setMiscSearchField(e.target.value));
    setSearchField(e.target.value)
  };

  const dumpVendorsData = async () => {
    startExportingData();
    setShouldExport(true);
    exportVendors();
  };

  const filteredData = occupations.filter((data: any) => {
    return data.name.toLowerCase().includes(searchField.toLowerCase());
  });

  return (
    <DashboardLayout
      pageTitle="Occupations"
      rhsHeading={
        <RhsHeading
          handleChange={handleChange}
          handleOpen={handleOpen}
          action="Occupation"
          handleExport={() => setShowExportModal(!showExportModal)}
        />
      }
    >
      <DashboardContainer>
        <ToastContainer />
        <AddOccupationModal
          open={open}
          fetchOccupation={() => window.location.reload()}
          handleClose={handleClose}
        />
        {isLoading ? (
          <div className="loader-container">
            <ScaleLoader color="#7E00C4" height={50} width={8} />
          </div>
        ) : (
          <OccupationTable
            rows={filteredData}
            fetchOccupation={() => window.location.reload()}
            Ppage={Ppage}
            setPage={setPage}
            paginationData={paginationData}
          />
        )}
      </DashboardContainer>
      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1={"Export Vendors"}
            content2="Are you sure you want to export vendors data?"
            btnAction={dumpVendorsData}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={exportingData}
          />
        }
      />
    </DashboardLayout>
  );
};

export default Occupation;
